import {
  ProviderUnavailableError,
  type ImageGenRequest,
  type ImageProvider,
  type ProviderImageJobState,
  type ProviderJobHandle,
} from "@loumy/contracts";

// §7 `image`-Provider (FLUX/Gemini-Slot, TBD §13). Echtes Adapter-Skeleton.
// `resolve(aspectRatio)` ist DETERMINISTISCH und brauchst KEINEN Key (reine
// Auflösung, im Job eingefroren, D30); nur `generate` braucht den API-Key.

export interface ImageProviderConfig {
  apiKey?: string;
  baseUrl?: string;
}

// PLACEHOLDER-Auflösungs-Tabelle (§13) — deterministisch je Aspect-Ratio (§10.2).
const ASPECT_TO_RESOLUTION: Record<string, string> = {
  "1:1": "1024x1024",
  "3:2": "1152x768",
  "2:3": "768x1152",
  "16:9": "1344x768",
  "9:16": "768x1344",
};

export class ConfigurableImageProvider implements ImageProvider {
  readonly id = "image-default";
  readonly version = 1;
  readonly displayName = "Image-Provider (PLACEHOLDER §13)";
  readonly limits = {
    supportedResolutions: Object.values(ASPECT_TO_RESOLUTION),
    maxRefs: 2,
    supportsGreenscreenDirective: true,
  };

  constructor(private readonly config: ImageProviderConfig = {}) {}

  /** deterministisch; Ergebnis wird beim Build in `params` eingefroren (D30). */
  resolve(aspectRatio: string): { resolution: string } {
    return { resolution: ASPECT_TO_RESOLUTION[aspectRatio] ?? ASPECT_TO_RESOLUTION["1:1"]! };
  }

  // D27: generate→Handle / poll→state (wie FalQwenImageProvider) — hier noch unverdrahtet (§13).
  async generate(_req: ImageGenRequest): Promise<ProviderJobHandle> {
    if (!this.config.apiKey)
      throw new ProviderUnavailableError("image", this.id, "IMAGE_API_KEY fehlt (Adapter nicht konfiguriert, §13).");
    // TODO(§13): echten FLUX/Gemini-Call verdrahten; Provenance REQUIRED (D39).
    throw new ProviderUnavailableError(
      "image",
      this.id,
      "Image-Provider-Endpoint offen (§13) — generate noch nicht verdrahtet (TODO §13).",
    );
  }

  async poll(_handle: ProviderJobHandle): Promise<ProviderImageJobState> {
    throw new ProviderUnavailableError(
      "image",
      this.id,
      "Image-Provider-Endpoint offen (§13) — poll noch nicht verdrahtet (TODO §13).",
    );
  }
}
